import React, { Fragment } from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { translateService } from 'services/TranslateService';
import { Subject } from 'rxjs/Subject';

interface IState extends IStateBase {
  value: string;
}

interface IProps {
  term: string;
  properties?: { [key: string]: any };
  className?: string;
}

export default class Translate extends BaseComponent<IState, IProps> {
  private term$: Subject<string>;

  constructor(props: any) {
    super(props);

    this.term$ = new Subject();
    this.term$.next(this.props.term);

    this.state = { value: this.props.term };
  }

  componentDidMount() {
    this.term$
      .distinctUntilChanged()
      .switchMap(term => translateService.getTextStream(term))
      .bindComponent(this)
      .subscribe(value => {
        this.setState({ value });
      });
  }

  render() {
    setTimeout(() => this.term$.next(this.props.term));

    if (!this.state.value) {
      return null;
    }

    const properties = this.props.properties || {};

    const parts: any[] = this.state.value.split(/(\{.*\})/gi);

    const propertyMap = Object.keys(properties).reduce((acc, key) => {
      acc[`{${key}}`] = properties[key];
      return acc;
    }, {});

    parts.forEach((word, index) => {
      propertyMap[word]
        ? parts[index] = <span className={this.props.className} key={index}>{propertyMap[word]}</span>
        : parts[index] = <span className={this.props.className} key={index}>{word}</span>;
    });

    return <Fragment>{parts}</Fragment>;
  }

}


// WEBPACK FOOTER //
// ./src/components/Translate.tsx